// extracted by mini-css-extract-plugin
export var section = "blog-module--section--1Oyl_";
export var no_margin = "blog-module--no_margin--3dXE3";
export var inner = "blog-module--inner--Y52Lc";
export var jsAnimInit = "blog-module--jsAnimInit--3svwB";
export var header = "blog-module--header--3SMBL";
export var subtitle = "blog-module--subtitle--oZmEC";
export var link = "blog-module--link--2VLb_";